import { ParsedUrlQueryInput, stringify } from 'querystring';

import cn from 'client/utils/cn';

import React, { Component } from 'react';

import { BunkerVideoItem, VideoType } from 'client/bundles/types';
import Card from 'client/components/card';
import Date from 'client/components/date';
import SvgIcon from 'client/components/svg-icon';
import LangContext from 'client/utils/lang-context';

import './index.css';

const b = cn('video-block');

type Props = Omit<BunkerVideoItem, 'id'>;

// eslint-disable-next-line no-useless-escape
const youtubeIdRe = /^.*(?:(?:youtu\.be)|(?:youtube\.com))\/(?:(?:embed\/)|(?:v\/)|(?:watch\?v=))?([^\/&?]{10,12})/;
const vhIdRe = /^(?:(?:.*frontend.vh.yandex.ru\/player\/)?([a-z0-9]{32})|(?:.*yandex.ru\/efir\?).*(?:stream_id=([a-z0-9]{32})))/;

const extractYoutubeIdFromUrl = (url: string): string => {
    const match = url.match(youtubeIdRe);

    return match ? match[1] : '';
};

const extractVHIdFromUrl = (url: string): string => {
    const match = url.match(vhIdRe);

    return match ? match[1] || match[2] : url;
};

const getYoutubeVideoUrl = (youtubeSrc: string): string => {
    const id = extractYoutubeIdFromUrl(youtubeSrc);
    const params: ParsedUrlQueryInput = {
        loop: '0',
        mute: '1'
    };

    return `https://www.youtube.com/embed/${id}?${stringify(params)}`;
};

const getVHUrl = (vhScr: string): string => {
    const id = extractVHIdFromUrl(vhScr);
    const params: ParsedUrlQueryInput = {
        loop: '0',
        autoplay: '0',
        mute: '1'
    };

    return `https://frontend.vh.yandex.ru/player/${id}?${stringify(params)}`;
};

class VideoBlock extends Component<Props> {
    static contextType = LangContext;

    get url() {
        const { url, type } = this.props;

        switch (type) {
            case VideoType.Youtube:
                return getYoutubeVideoUrl(url);
            case VideoType.VH:
                return getVHUrl(url);
            default:
                return null;
        }
    }

    getTimeFromMins = (mins: number) => {
        const { dictionary } = this.context;
        const hours = Math.trunc(mins / 60);
        const minutes = mins % 60;

        return `${hours > 0 ? `${hours} ${dictionary.hours} ` : ''}${minutes > 0 ? `${minutes} ${dictionary.minutes}` : ''}`.trim();
    }

    renderVideo() {
        return this.url && (
            <div className={b('video')}>
                <iframe
                    allowFullScreen
                    frameBorder="no"
                    scrolling="no"
                    allow="fullscreen; accelerometer; gyroscope; picture-in-picture; encrypted-media"
                    className={b('iframe')}
                    src={this.url}
                    />
            </div>
        );
    }

    render() {
        const {
            date,
            title,
            description,
            duration
        } = this.props;

        return (
            <div className={b()}>
                <Card noPadding>
                    <div className={b('content')}>
                        <div className={b('left-column')}>
                            {this.renderVideo()}
                        </div>

                        <div className={b('right-column')}>
                            <Date dateStart={date} />

                            <h2 className={b('title')}>{title}</h2>

                            <div className={b('description')} dangerouslySetInnerHTML={{ __html: description }} />

                            <div className={b('duration')}>
                                <SvgIcon mix={b('icon')} icon="time" />

                                {this.getTimeFromMins(Number(duration))}
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
        );
    }
}

export default VideoBlock;
